import { progressPrefixCls } from "@/base/components/progress/Progress.component";
import { THEME_PREFIX } from "@/base/constant";
import {
  genComponentStyleHook,
  type FullToken,
  type GenerateStyle,
} from "antd/es/theme/internal";

const genStyle: GenerateStyle<FullToken<"Progress">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${progressPrefixCls}`]: {
      [`.${progressPrefixCls}-text-inner`]: {
        padding: `0 12px`,
      },
      [`.${progressPrefixCls}-steps-item`]: {
        borderRadius: `0.125em !important`,
      },
    },
  },
});

export const useProgressStyle = genComponentStyleHook(
  ["Progress", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
